import React from 'react';
import PropTypes from 'prop-types';
import { ErrorMessage as ErrorMessageFormik } from 'formik';

import { ErrorMessageStyled } from './ErrorMessage.styled';

const ErrorMessage = (props) => (
  <ErrorMessageFormik {...props}>
    {(msg) => <ErrorMessageStyled {...props}>{Array.isArray(msg) ? msg[0] : msg}</ErrorMessageStyled>}
  </ErrorMessageFormik>
);

ErrorMessage.propTypes = {
  children: PropTypes.node,
};

ErrorMessage.defaultProps = {
  children: '',
};

export default ErrorMessage;
